import SelectQuestionType from "pages/QuestionPage/SelectQuestionType/SelectQuestionType";

export default SelectQuestionType;
